<h5>Tarefas para cobranças</h5>

<div ngbAccordion #acc="ngbAccordion">
    
    <div ngbAccordionItem [collapsed]="false">
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Emitir Cobrança</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-warning p-1 mb-1" role="alert">
                                ⚠️ Este teste realiza integração com o IBM Mainframe, estando sujeito a instabilidades. Emissões de cobrança devem ser feitas na data corrente (sem uso de máquina do tempo). 
                                Além disso, se for necessário baixar o boleto da cobrança (PDF), isto deve ser feito solicitando o job IEPJ21H pela T999H5 (solicitar à ATI). Para simulações de emissão de cobranças simples, utilize a tarefa "Simular emissão de cobrança."
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="submit col-auto">
                            <button type="button" (click)="emite()" class="btn btn-success no-margin">Emitir</button>
                        </div>

                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title2">Baixar Cobrança</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-warning p-1 mb-1" role="alert">
                                ⚠️ Este teste realiza integração com o IBM Mainframe, estando sujeito a instabilidades. 
                                Para simulações de baixa de cobranças simples, utilize a tarefa "Simular baixa de cobrança."
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="baixarPeloValorIntegral == true; else liberaValorSimulacao">

                        <div class="col-md-3">
                            <label for="valor">ID Cobrança: </label>
                            <input type="text" id="ideCobranca" class="form-control"
                            [(ngModel)]="ideCobranca" bnMask="INTEIRO">
                        </div>

                        <div class="col-md-3">
                            <label>Data simulação do pagamento:</label>
                            <bn-datepicker
                                name="dataSimulacaoPagamento"
                                idInput="dataSimulacaoPagamento"
                                ngDefaultControl
                                [(ngModel)]="dataSimulacaoPagamento">
                            </bn-datepicker>
                        </div>

                        <div class="col-md-3">
                            <label for="valor">Valor simulação do pagamento: </label>
                            <input type="text" id="valorSimulacaoPagamento" class="form-control"
                            [(ngModel)]="valorSimulacaoPagamento" bnMask="MOEDA" disabled>
                        </div>

                        <div class="col-md-3">
                            <label>Baixar pelo valor integral: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                ngbTooltip="Desabilite para poder preencher o campo valor simulação do pagamento"></i></label>
                                <input type="checkbox" class="form-check checkbox-gigante" name="baixarPeloValorIntegral"
                                [(ngModel)]="baixarPeloValorIntegral">
                        </div>

                    </div>
                    <ng-template #liberaValorSimulacao>
                        <div class="row">
                            <div class="col-md-3">
                                <label for="valor">ID Cobrança: </label>
                                <input type="text" id="ideCobranca" class="form-control"
                                [(ngModel)]="ideCobranca" bnMask="INTEIRO">
                            </div>

                            <div class="col-md-3">
                                <label>Data simulação do pagamento:</label>
                                <bn-datepicker
                                    name="dataSimulacaoPagamento"
                                    idInput="dataSimulacaoPagamento"
                                    ngDefaultControl
                                    [(ngModel)]="dataSimulacaoPagamento">
                                </bn-datepicker>
                            </div>

                            <div class="col-md-3">
                                <label for="valor">Valor simulação do pagamento: </label>
                                <input type="text" id="valorSimulacaoPagamento" class="form-control"
                                [(ngModel)]="valorSimulacaoPagamento" bnMask="MOEDA">
                            </div>

                            <div class="col-md-3">
                                <label>Baixar pelo valor integral:</label>
                                    <input type="checkbox" class="form-check checkbox-gigante" name="baixarPeloValorIntegral"
                                    [(ngModel)]="baixarPeloValorIntegral">
                            </div>
                        </div>

                    </ng-template>

                    <div class="row">
                        <div class="submit col-auto" *ngIf="
                        (ideCobranca == null || dataSimulacaoPagamento == null) &&
                        (liberaValorSimulacao == false || valorSimulacaoPagamento == null)
                        ;else liberaBaixar">
                            <button type="button" disabled (click)="baixa()" class="btn btn-success no-margin">Baixar</button>
                        </div>
                        <ng-template #liberaBaixar>
                            <div class="submit col-auto">
                                <button type="button" (click)="baixa()" class="btn btn-success no-margin">Baixar</button>
                            </div>
                        </ng-template>


                        <div class="submit col-auto">
                            <button type="button" (click)="limparBaixarCobranca()" class="btn btn-light">Limpar</button>
                        </div>

                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Simular emissão de cobrança</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="submit col-auto">
                            <button type="button" (click)="simularEmissao()" class="btn btn-success no-margin">Simular emissão de cobrança</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Simular baixa de cobrança</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="valor">ID Cobrança: </label>
                            <input type="text" id="ideCobranca" class="form-control"
                            [(ngModel)]="ideCobranca" bnMask="INTEIRO">
                        </div>
                        <div class="submit col-auto">
                            <button type="button" (click)="simularBaixa()" class="btn btn-success no-margin">Simular baixa</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title3">Gerar Planilha SCC</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">

                        <div class="col-md-12">
                            <label for="valor">Email: </label>
                            <input type="text" name="emailsEnvioPlanilha" class="form-control"
                            [(ngModel)]="emailsEnvioPlanilha"
                            placeholder="Preencha com um ou mais endereços de email sem o @ separando-os por ponto e vírgula">
                        </div>

                    </div>

                    <div class="row">
                        <div class="submit col-auto" *ngIf="emailsEnvioPlanilha == null; else liberaGerarPlanilha">
                            <button type="button" disabled (click)="geraPlanilhaSCC()" class="btn btn-success no-margin">Gerar</button>
                        </div>
                        <ng-template #liberaGerarPlanilha>
                            <div class="submit col-auto">
                                <button type="button" (click)="geraPlanilhaSCC()" class="btn btn-success no-margin">Gerar</button>
                            </div>
                        </ng-template>

                            <div class="submit col-auto">
                                <button type="button" (click)="limparGerarPlanilha()" class="btn btn-light">Limpar</button>
                            </div>

                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title4">Gerar Contabilizações</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">

                        <div class="col-md-12">
                            <label for="valor">Email: </label>
                            <input type="email" multiple id="emailsEnvioContabilizacoes" class="form-control"
                            [(ngModel)]="emailsEnvioContabilizacoes"
                            placeholder="Preencha com um ou mais endereços de email sem o @ separando-os por ponto e vírgula">
                        </div>

                    </div>

                    <div class="row">
                        <div class="submit col-auto" *ngIf="emailsEnvioContabilizacoes == null; else liberaGerarContabilizacoes">
                            <button type="button" disabled (click)="geraContabilizacoes()" class="btn btn-success no-margin">Gerar</button>
                        </div>
                        <ng-template #liberaGerarContabilizacoes>
                            <div class="submit col-auto">
                                <button type="button" (click)="geraContabilizacoes()" class="btn btn-success no-margin">Gerar</button>
                            </div>
                        </ng-template>

                            <div class="submit col-auto">
                                <button type="button" (click)="limparGerarContabilizacoes()" class="btn btn-light">Limpar</button>
                            </div>

                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title4">Sincronizar VSAM/RCC</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">

                        <div class="col-md-2">
                            <label for="idSistema">Sistema: *</label>
                            <select type="text" id="idSistema" class="form-select" bnMask="INTEIRO" [(ngModel)]="idSistema">
                                <option>15</option>
                                <option selected>84</option>
                                <option>89</option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label>Localização do VSAM: * </label>
                            <ng-template #tipoOperacao>IBM -> Prefixo do VSAM. <br> Local -> Arquivo VSAM.</ng-template>
                            <span [ngbTooltip]="tipoOperacao" placement="top"> <i class="fa fa-question-circle help-subtitulo" placement="bottom"> </i> </span> 
                                <div style="padding-top: 5px;">
                                <input [disabled]="local" type="checkbox" class="form-check checkbox-gigante" name="ibm"
                                [(ngModel)]="ibm" style="display:inline-block;" (change)="onLocalizacaoChange($event)">
                                <span style="display:inline-block;padding-right: 10px;vertical-align: top;">IBM</span>
                                <input [disabled]="ibm" type="checkbox" class="form-check checkbox-gigante" name="local"
                                [(ngModel)]="local" style="display:inline-block;" (change)="onLocalizacaoChange($event)">
                                <span style="display:inline-block;vertical-align: top;">Local</span>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label for="numeroContrato">Prefixo do VSAM</label>
                            <input [disabled]="!ibm" type="text" id="prefixoVsam" class="form-control" maxlength="20"
                                [required]="true" [(ngModel)]="prefixoVsam" >
                        </div>

                        <div class="row" class="col-md-4">
                            <label for="arquivo">Arquivo VSAM:</label>
                            <div id="customFile">
                                <input [disabled]="!local" type="file" accept=".vsm" class="form-control" id="arquivo" onclick="this.value=null;"
                                (change)="onFileChange($event)" #fileInput  />
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="submit col-auto">
                            <button [disabled]="!((ibm && prefixoVsam) || ( local && anexoVsam))" type="button" (click)="ibm?sincronizarVsamRcc():sincronizarVsamRccComArquivoEnviadoPeloPortal()" class="btn btn-success no-margin">Sincronizar</button>
                        </div>
                            <div class="submit col-auto">
                                <button type="button" (click)="limparSincronizarVsamRcc()" class="btn btn-light">Limpar</button>
                            </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>

